import { TabIconType } from '../../ui/views/View'

export enum ViewType {
	// Lobby views
	LOGIN = 'LOGIN',
	LOBBY = 'LOBBY',
	SLOTS_LOBBY = 'SLOTS_LOBBY',

	// Game views
	POKER_TABLE = 'POKER_TABLE',
	POKER_TABLE_EXTERNAL = 'POKER_TABLE_EXTERNAL',
	MULTI_TABLE = 'MULTI_TABLE',
	TOURNAMENT = 'TOURNAMENT',
	SLOTS = 'SLOTS',
	SLOTS_EXTERNAL = 'SLOTS_EXTERNAL',
	BLACKJACK = 'BLACKJACK',
	GAP_SLOTS = 'GAP_SLOTS',

	// Other views
	PROFILE = 'PROFILE',
	EXTERNAL_PAGE = 'EXTERNAL_PAGE',
}

type BaseView = {
	id: number
	name: string
	isActive: boolean
	tabIconType?: TabIconType
	isHidden?: boolean
	parentViewId?: number
}

export type LobbyView = BaseView & {
	type: ViewType.LOGIN | ViewType.LOBBY | ViewType.SLOTS_LOBBY
	isGame: false
}

export type PokerTableView = BaseView & {
	type: ViewType.POKER_TABLE
	tableId?: number
	groupId?: number
	isGame: true
}

export type ExternalPokerTableView = BaseView & {
	type: ViewType.POKER_TABLE_EXTERNAL
	tableId?: number
	groupId?: number
	isGame: true
}

export type MultiTableView = BaseView & {
	type: ViewType.MULTI_TABLE
	containedTableIds?: (number | string)[]
	isGame: true
}

export type TournamentView = BaseView & {
	type: ViewType.TOURNAMENT
	tournamentId?: number
	isGame: false
}

export type CasinoGameView = BaseView & {
	type: ViewType.SLOTS | ViewType.BLACKJACK | ViewType.GAP_SLOTS
	tableId?: string
	groupId?: number
	isGame: true
}

export type ExternalCasinoView = BaseView & {
	type: ViewType.SLOTS_EXTERNAL
	groupId?: number
	isGame: true
}

export type ProfileView = BaseView & {
	type: ViewType.PROFILE
	section?: string
	isGame: false
}

export type ExternalPageView = BaseView & {
	type: ViewType.EXTERNAL_PAGE
	url?: string
	isGame: false
}

export type View =
	| LobbyView
	| PokerTableView
	| ExternalPokerTableView
	| MultiTableView
	| TournamentView
	| CasinoGameView
	| ExternalCasinoView
	| ProfileView
	| ExternalPageView

export type ViewsState = {
	views: View[]
	mainWindowActiveViewId: number | null
	externalWindowActiveViewIds: number[]
	multiTableViewId: number | null
}

export const initialViewsState: ViewsState = {
	views: [],
	mainWindowActiveViewId: null,
	externalWindowActiveViewIds: [],
	multiTableViewId: null,
}
